class collectionGridItem extends HTMLElement {
    constructor() {
        super();

        this.mainCollection = document.querySelector(".collection-content");
        this.desktopPosition = parseInt(this.dataset.desktopPosition);
        this.mobilePosition = parseInt(this.dataset.mobilePosition);

        this.init();

        document.addEventListener("collection-grid-item:init", this.init.bind(this));
    };

    init() {
        this.appendGridItem();
    };

    appendGridItem() {
        if(document.documentElement.clientWidth > 990) {
            const targetProductItem = this.mainCollection.querySelector(`#product-grid .grid__item:nth-child(${this.desktopPosition})`);
            
            if(targetProductItem) {
                targetProductItem.insertAdjacentHTML("afterEnd",this.innerHTML)
            }
        }else {
            const targetProductItem = this.mainCollection.querySelector(`#product-grid .grid__item:nth-child(${this.mobilePosition})`);

            if(targetProductItem) {
                targetProductItem.insertAdjacentHTML("afterEnd",this.innerHTML)
            }
        }
    };
}
  
customElements.define('collection-grid-item', collectionGridItem);